const HALF_WIDTH_TO_FULL_WIDTH = {
  ｦ: "ヲ",
  ｧ: "ァ",
  ｨ: "ィ",
  ｩ: "ゥ",
  ｪ: "ェ",
  ｫ: "ォ",
  ｬ: "ャ",
  ｭ: "ュ",
  ｮ: "ョ",
  ｯ: "ッ",
  ｰ: "ー",
  ｱ: "ア",
  ｲ: "イ",
  ｳ: "ウ",
  ｴ: "エ",
  ｵ: "オ",
  ｶ: "カ",
  ｷ: "キ",
  ｸ: "ク",
  ｹ: "ケ",
  ｺ: "コ",
  ｻ: "サ",
  ｼ: "シ",
  ｽ: "ス",
  ｾ: "セ",
  ｿ: "ソ",
  ﾀ: "タ",
  ﾁ: "チ",
  ﾂ: "ツ",
  ﾃ: "テ",
  ﾄ: "ト",
  ﾅ: "ナ",
  ﾆ: "ニ",
  ﾇ: "ヌ",
  ﾈ: "ネ",
  ﾉ: "ノ",
  ﾊ: "ハ",
  ﾋ: "ヒ",
  ﾌ: "フ",
  ﾍ: "ヘ",
  ﾎ: "ホ",
  ﾏ: "マ",
  ﾐ: "ミ",
  ﾑ: "ム",
  ﾒ: "メ",
  ﾓ: "モ",
  ﾔ: "ヤ",
  ﾕ: "ユ",
  ﾖ: "ヨ",
  ﾗ: "ラ",
  ﾘ: "リ",
  ﾙ: "ル",
  ﾚ: "レ",
  ﾛ: "ロ",
  ﾜ: "ワ",
  ﾝ: "ン",
  " ": "　",
  "¢": "￠",
  "£": "￡",
  "¬": "￢",
  "¯": "￣",
  "¦": "￤",
  "¥": "￥",
  "₩": "￦",
  "⦆": "｠",
  "⦅": "｟"
};
const FULL_WIDTH_TO_HALF_WIDTH = Object.entries(
  HALF_WIDTH_TO_FULL_WIDTH
).reduce((acc, curr) => {
  acc[curr[1]] = curr[0];
  return acc;
}, {});
function convertJapaneseSpecificCharsToFullWidth(text) {
  return text.replaceAll("ｸﾞ", "グ");
}
function convertJapaneseSpecificCharsToHalfWidth(text) {
  return text.replaceAll("グ", "ｸﾞ");
}
function convertToFullWidth(text) {
  return [...toFullWidthAscii(text)].map((c) => HALF_WIDTH_TO_FULL_WIDTH[c] || c).join("");
}
function convertFromFullwidth(text) {
  return [...toHalfWidthAscii(text)].map((c) => FULL_WIDTH_TO_HALF_WIDTH[c] || c).join("");
}
function toHalfWidthAscii(str) {
  return convertJapaneseSpecificCharsToHalfWidth(str).replaceAll(
    // eslint-disable-next-line regexp/no-obscure-range
    /[！-～]/g,
    (c) => shiftCharCode(c, { toHalfWidthAscii: true })
  );
}
function toFullWidthAscii(str) {
  return convertJapaneseSpecificCharsToFullWidth(str).replaceAll(
    // eslint-disable-next-line regexp/no-obscure-range
    /[!-~]/g,
    (c) => shiftCharCode(c, { toHalfWidthAscii: false })
  );
}
function shiftCharCode(char, { toHalfWidthAscii: toHalfWidthAscii2 }) {
  const codePointChar = char.codePointAt(0);
  const codePointFullWidth = "！".codePointAt(0);
  const codePointHalfWidth = "!".codePointAt(0);
  if (codePointChar === void 0 || codePointFullWidth === void 0 || codePointHalfWidth === void 0) {
    return char;
  }
  const delta = toHalfWidthAscii2 ? codePointHalfWidth - codePointFullWidth : codePointFullWidth - codePointHalfWidth;
  return String.fromCodePoint(codePointChar + delta);
}
export {
  convertFromFullwidth,
  convertToFullWidth
};
//# sourceMappingURL=halfwidth-fullwidth-converter.js.map
